import styled from '@emotion/styled';
import {
  compose,
  TypographyProps,
  typography,
  SpaceProps,
  space,
  variant,
  border,
  BorderProps,
  BackgroundProps,
  background
} from '@lucid/theme';
import { AccordionItemPanel } from 'react-accessible-accordion';

export type AccordionPanelVariants = 'default' | 'inverse';

export interface AccordionPanelProps
  extends BackgroundProps,
    TypographyProps,
    SpaceProps,
    BorderProps {
      /** The available variants for the Accordion.Panel component. */
      variant?: AccordionPanelVariants;
    }

const panelStyleProps = compose(background, typography, space, border);

const AccordionPanel = styled(AccordionItemPanel)<AccordionPanelProps>(
  {
    label: 'panel'
  },
  variant({
    scale: 'accordion.panel',
    variants: {
      defaultVariant: {}
    }
  }),
  panelStyleProps
);

export { AccordionPanel };
export default AccordionPanel;
